import { posthog, getCommonTrackingProperties } from '@/composables/usePosthog'

// Both checkouts add to the cart from the same modal, so an add has to emit the same three things
// either way: the PostHog event, the GA/GTM hook bus, and the Meta pixel. V2 shipped with none of
// them; owning the set here is what stops one version quietly dropping one again.
//
// `store` is the Vuex store (or any component with a `$store`) - `getCommonTrackingProperties`
// accepts either, and V2 still reaches Vuex for merchant/bottle identity even though its cart and
// catalogue come from TanStack Query.
export function trackProductAdd(
  store,
  { isUpsell = false, quantity, productId, productName, eventName = 'added_cart_item_via_modal', eventCount } = {}
) {
  // The modal's CTA doubles as "Remove from cart" at a quantity of 0. That is not an add, and
  // reporting it as one would inflate the pixel and the funnel alike.
  if (!(Number(quantity) > 0)) return

  // Nothing here is worth failing an add over: a missing store costs the common properties, not
  // the line the customer just configured.
  const vuex = store?.$store || store
  posthog.capture(isUpsell ? `upsells_${eventName}` : eventName, {
    ...(vuex ? getCommonTrackingProperties(vuex) : {}),
    count: eventCount ?? quantity
  })

  window.bottle?.hooks?.v1?.emit('add_to_cart', {
    items: [{ item_id: productId, item_name: productName, quantity }]
  })

  if (vuex?.getters?.info?.attributes?.facebook_pixel_container_id && typeof window.fbq === 'function') {
    window.fbq('track', 'AddToCart', { product_name: productName, quantity, product_id: productId })
  }
}
